@let navigationItemsValue = navigationItems();
@let accessibleNavigationItemsValue = accessibleNavigationItems();
@let visibleTopNavigationItemsCountValue = visibleTopNavigationItemsCount();
@let isDropdownOpenValue = isDropdownOpen();

<div class="top-navigation">
  <div #navigationItemsPanelElement class="top-navigation__items">
    @let visibleNavigationItems = accessibleNavigationItemsValue | slice: 0 : visibleTopNavigationItemsCountValue;

    <ng-container *ngTemplateOutlet="navigationItemsTemplate; context: { $implicit: visibleNavigationItems }" />

    @if (visibleTopNavigationItemsCountValue < navigationItemsElements().length) {
      <button
        #trigger="cdkOverlayOrigin"
        cdkOverlayOrigin
        type="button"
        class="top-navigation__item"
        [class.top-navigation__item--active]="isDropdownOpenValue"
        [attr.aria-expanded]="isDropdownOpenValue"
        (click)="toggleDropdown()"
      >
        {{ 'navigation.more' | translate }}
        <i aria-hidden="true" class="top-navigation__toggle-icon fa-regular fa-chevron-down fa--header-texticon"></i>
      </button>

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="isDropdownOpenValue"
        [cdkConnectedOverlayDisableClose]="true"
        (detach)="isDropdownOpen.set(false)"
      >
        <itc-top-navigation-dropdown
          [trigger]="trigger"
          [navigationItems]="accessibleNavigationItemsValue | slice: visibleTopNavigationItemsCountValue"
          [(isDropdownOpen)]="isDropdownOpen"
        />
      </ng-template>
    }
  </div>

  <div #hiddenOverlay class="top-navigation__hidden-items-overlay">
    <ng-container *ngTemplateOutlet="navigationItemsTemplate; context: { $implicit: navigationItemsValue }" />
  </div>
</div>

<ng-template #kaseyaStoreItemContent let-isKaseyaStoreSsoLinkLoading="isLoading" let-navigationItem>
  {{ navigationItem.labelTranslateKey | translate }}

  @if (isKaseyaStoreSsoLinkLoading) {
    <kds-spinner variant="inline" />
  } @else {
    <i aria-hidden="true" class="top-navigation__icon fa-regular fa-external-link fa--header-texticon"></i>
  }
</ng-template>

<ng-template #navigationItemsTemplate let-navigationItems>
  @for (navigationItem of navigationItems; track navigationItem.id) {
    <ng-container *itcFeature="navigationItem.features">
      <ng-container *itcCountryAccess="navigationItem.accessibleCountries">
        @switch (navigationItem.id) {
          @case (TopNavigationPath.KaseyaStore) {
            @let isKaseyaStoreSsoLinkLoading = isKaseyaStoreSsoLinkLoading$ | async;

            @if (isMigratedUser) {
              <button
                *itcPermission="Permission.SalesforceECommerce"
                #navItem
                type="button"
                class="top-navigation__item"
                [attr.data-nav-id]="navigationItem.id"
                [class.top-navigation__item--loading]="isKaseyaStoreSsoLinkLoading"
                [itcOpenSsoSalesforceLink]="SsoSalesforceDestination.Home"
                [isLoading$]="isKaseyaStoreSsoLinkLoading$"
              >
                <ng-template
                  *ngTemplateOutlet="kaseyaStoreItemContent; context: { $implicit: navigationItem, isLoading: isKaseyaStoreSsoLinkLoading }"
                />
              </button>
            } @else {
              <button
                *itcPermission="navigationItem.permissions"
                #navItem
                type="button"
                class="top-navigation__item"
                [attr.data-nav-id]="navigationItem.id"
                [class.top-navigation__item--loading]="isKaseyaStoreSsoLinkLoading"
                [itcOpenSsoLink]="SsoTargetPage.KaseyaStore"
                [isLoading$]="isKaseyaStoreSsoLinkLoading$"
              >
                <ng-template
                  *ngTemplateOutlet="kaseyaStoreItemContent; context: { $implicit: navigationItem, isLoading: isKaseyaStoreSsoLinkLoading }"
                />
              </button>
            }
          }
          @default {
            <a
              *itcPermission="navigationItem.permissions"
              #navItem
              class="top-navigation__item"
              routerLinkActive="top-navigation__item--active"
              ariaCurrentWhenActive="page"
              kdsPrefetch
              [attr.data-nav-id]="navigationItem.id"
              [routerLink]="navigationItem.id"
              (isActiveChange)="setActiveTopNavigation(navigationItem.id, $event)"
            >
              {{ navigationItem.labelTranslateKey | translate }}
            </a>
          }
        }
      </ng-container>
    </ng-container>
  }
</ng-template>
